// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./src/main/main.js");
__webpack_require__("./src/main/task-list.js");
var __webpack_exports__ = __webpack_require__("./src/main/task.js");
